/**
 * Created by Languagenut on 24/04/2019.
 */


import React  from 'react';
import {Form } from 'react-bootstrap';

export default function FieldGroup({ state , id, label, help, ...props }) {
    return (
        <Form.Group className='input-field' controlId={id} validationState={state}>
            <Form.Label>{label}</Form.Label>
            <Form.Control  className='input-field' {...props} />

            {help && <small>{help}</small>}
        </Form.Group>
    );
}
